import { apiClient } from 'utils/api';
import type { ActivitiesMetadata } from './types.activities';

class ActivitiesMetadataService {
  async get(options: { signal: AbortSignal }): Promise<ActivitiesMetadata> {
    return apiClient.get<ActivitiesMetadata>('/workflows/metadata/activities', options);
  }
}

export default new ActivitiesMetadataService();
